// @ts-nocheck
import { Empty } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";

export default function EndList({ userkjList }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const getNode = () => {
    const nodes = [];
    for (let index = 0; index < userkjList.length; index++) {
      const data = userkjList[index];
      if (data.status !== 1) {
        const node = (
          <div key={index} className="bg-neutral-800 rounded-lg p-4 mb-4 shadow-card border border-neutral-700">
            <div className="flex flex-col space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <img
                    alt=""
                    src={imageConfig.baseImageUrl+data.imgs}
                    className="w-8 h-8 rounded-full"
                  />
                  <span className="ml-3 text-base font-medium text-white">{data.kjtitle}</span>
                </div>
                <span className="text-xs text-neutral-400">{data.endtime}</span>
              </div>
              
              <div className="grid grid-cols-3 gap-4 mt-3 pt-3 border-t border-neutral-700">
                <div className="flex flex-col">
                  <span className="text-xs text-neutral-400">
                    {translate(getText("購買金額"))}
                  </span>
                  <span className="text-sm text-white mt-1 font-medium">{data.buynum}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-neutral-400">
                    {translate(getText("日收益率"))}
                  </span>
                  <span className="text-sm text-success mt-1 font-medium">{data.outnum}%</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-neutral-400">
                    {translate(getText("收益次数"))}
                  </span>
                  <span className="text-sm text-white mt-1 font-medium">{data.synum}</span>
                </div>
              </div>
            </div>
          </div>
        );
        nodes.push(node);
      }
    }
    //判断空
    if (nodes.length === 0) {
      nodes.push(
        <div className="flex items-center justify-center py-10">
          <Empty description={translate(getText("暂无更多了"))} />
        </div>
      );
    }
    return nodes;
  };
  return (
    <div className="px-4">
      {getNode()}
      <div className="h-16"></div>
    </div>
  );
}
